export default {
    namespaced: true,
    
    state:
    {
        lv:
        {
            'Add todo': 'Pievienot',
            'What needs to be done?': 'Kas šodien jāizdara?',
            'Delete selected': 'Dzēst atzīmētos',
        },

        en:
        {
            'Add todo': 'Add todo',
            'What needs to be done?': 'What needs to be done?',
            'Delete selected': 'Delete selected',
        },
    },
}